import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../../lib/icons';
import { DomiraLogo } from '../common/Logo';
import { domiraNav } from '../../data/config';
import { Button } from '../common/Button';

export function DomiraHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-paelbi-line/70 bg-paelbi-bg/90 backdrop-blur-md">
      <div className="mx-auto flex h-[72px] max-w-container items-center justify-between px-6">
        <Link to="/" aria-label="Domira Solutions home" className="shrink-0">
          <DomiraLogo />
        </Link>

        <nav className="hidden lg:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
          {domiraNav.map((item) => (
            <a key={item.label} href={item.path} className="font-sans text-[15px] text-paelbi-ink/80 transition-colors hover:text-paelbi-brown">
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button to="/admin/login" variant="primary" className="hidden sm:inline-flex h-11 px-6 text-sm" data-testid="header-login-desktop">Accedi</Button>
          <button
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-btn text-paelbi-ink"
            aria-label={open ? 'Chiudi menu' : 'Apri menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <Icon name={open ? 'close' : 'menu'} size={26} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-paelbi-line bg-paelbi-bg">
          <nav className="mx-auto flex max-w-container flex-col px-6 py-4">
            {domiraNav.map((item) => (
              <a key={item.label} href={item.path} onClick={() => setOpen(false)} className="border-b border-paelbi-line/60 py-3 font-sans text-[15px] text-paelbi-ink/80">
                {item.label}
              </a>
            ))}
            <Button to="/admin/login" variant="primary" className="mt-4 h-11 text-sm" data-testid="header-login-mobile">Accedi</Button>
          </nav>
        </div>
      )}
      </header>
  );
}

export default DomiraHeader;
